'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = (0, _styledBase2.default)('div', {
	target: 'e1nzkzy80',
	label: 'Container'
})(function (_ref) {
	var theme = _ref.theme;
	return theme.component;
}, ';' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvQ29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0QiIsImZpbGUiOiIuLi8uLi9zcmMvc3R5bGVzL0NvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcblx0JHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb21wb25lbnR9O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyO1xuIl19 */'));

exports.default = Container;